import { createContext } from 'react'

// Which identity provider handles login (WO-15). Clerk by default; 'supabase' keeps the legacy
// Supabase/GoTrue path available behind a build-time flag (SoT 5.8 fallback).
export const AUTH_PROVIDER = (process.env.REACT_APP_AUTH_PROVIDER || 'clerk').toLowerCase()

// Shape shared by every provider: user, profile, preferredCurrency, setPreferredCurrency, session,
// loading, accountError, authProvider, signUp, signIn, signInWithGoogle, signOut, updateProfile,
// loadUserProfile, clearAuthState, changePassword, sendPasswordReset, openAccountSettings.
// user.id is always OUR user id (users.id), never the provider's id.
export const AuthContext = createContext(null)
